import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '@environments/environment';
import {Subject} from 'rxjs';
import {tap} from 'rxjs/operators';
import {
  WidgetCustomizationAiRequest,
  WidgetCustomizationAiResult
} from '@app/_components/widget-customization-ai/widget-customization-ai.types';

@Injectable({providedIn: 'root'})
export class GlobalWidgetService {
  private readonly url = `${environment.apiUrl}/api/v1/global-widget`;
  private readonly savedSubject = new Subject<void>();
  readonly saved$ = this.savedSubject.asObservable();

  constructor(private http: HttpClient) {}

  list(params: any = {}) {
    return this.http.get<any>(this.url, {params});
  }

  get(id: number) {
    return this.http.get<any>(`${this.url}/${id}`);
  }

  create(payload: any) {
    return this.http.post<any>(this.url, payload).pipe(
      tap(() => this.savedSubject.next())
    );
  }

  update(id: number, payload: any) {
    return this.http.put<any>(`${this.url}/${id}`, payload).pipe(
      tap(() => this.savedSubject.next())
    );
  }

  delete(id: number) {
    return this.http.delete<any>(`${this.url}/${id}`);
  }

  getForProject(projectId: number) {
    return this.http.get<any>(`${this.url}/project/${projectId}`);
  }

  generateWidgetCustomization(payload: WidgetCustomizationAiRequest) {
    return this.http.post<{success: boolean; data: WidgetCustomizationAiResult}>(
      `${this.url}/widget-customization/ai/generate`,
      payload
    );
  }

  projects(id: number) {
    return this.http.get<any>(`${this.url}/${id}/projects`);
  }

}
